import React from 'react';

// Badge « propulsé par Jalonne » sur les pages publiques.
// Contrôlé côté serveur (poweredBy dans les payloads publics) :
// affiché en plan Essentiel, retirable à partir du plan Pro.
export default function PoweredByBadge({ show }) {
  if (!show) return null;
  return (
    <div style={{ textAlign: 'center', padding: '10px 16px', background: 'rgba(0,0,0,0.04)' }}>
      <a
        href="https://jalonne.fr"
        target="_blank"
        rel="noreferrer"
        style={{ fontSize: '0.75rem', color: '#64748b', textDecoration: 'none', letterSpacing: '0.3px' }}
      >
        ⚡ Propulsé par <strong>Jalonne</strong> — le suivi de chantier par QR code
      </a>
    </div>
  );
}
